import { Attr, BelongsTo, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { BillingGroup } from "./billingGroup"
// Cannot yet be imported as a type
// because the class must be imported somewhere for it to be added to the modelRegistry
// See spraypaint.js/src/decorators.js -> modelFactory() -> ModelClass.registerType()
import { MeterSourceType } from "./meterSourceType"
import type { Site } from "./site"

export interface IMeterCounts {
  meterHours: number
}
@Model()
export class Meter extends ApplicationRecord {
  public static readonly jsonapiType = "meters"

  // Cannot yet be written as a string (e.g. @BelongsTo("meter_source_types"))
  // because the class must be imported somewhere for it to be added to the modelRegistry
  @BelongsTo(MeterSourceType) meterSourceType!: MeterSourceType

  @BelongsTo("sites") public site!: Site

  @BelongsTo("billing_groups") public billingGroup!: BillingGroup

  @Attr() public readonly name!: string

  @Attr() public meterCode!: string

  @Attr() public readonly meterStatus!: string

  @Attr() public readonly meterType!: string

  @Attr() public meterProvider!: string

  @Attr() public readonly energyAllocatorId!: string

  @Attr() public readonly energyAllocatorName!: string

  /** From energy allocator or GHG; only present when requested via extra_fields. */
  @Attr() public readonly emissionFactorDisplay!: string | null

  @Attr() public readonly billingGroupId!: number

  @Attr() public readonly siteId!: number

  @Attr() public readonly dateCreated!: string

  @Attr() public readonly dateUpdated!: string

  @Attr() public readonly fullMeter!: boolean

  @Attr() public readonly probeMeter!: boolean

  @Attr() public readonly isOnSiteGeneration!: boolean

  @Attr() public readonly isNetMeter!: boolean

  @Attr() public readonly isChildMeter!: boolean

  @Attr() public accountNumber!: string

  @Attr() public readonly startDate!: string

  @Attr() public readonly endDate!: string

  @Attr() public childMeterNamesAndIds!: {
    id: typeof Meter.prototype.id
    meterCode: typeof Meter.prototype.meterCode
    name: typeof Meter.prototype.name
  }[]
}
